import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, MessageSquare, GitBranch, Play, FileText, BarChart, Settings, Phone, Users, ChevronDown, ChevronRight, Book, UserCircle, Calendar } from 'lucide-react';
const Sidebar = () => {
  const location = useLocation();
  const [expandedSection, setExpandedSection] = useState('management');
  const toggleSection = section => {
    setExpandedSection(expandedSection === section ? null : section);
  };
  const isActive = path => {
    return location.pathname === path;
  };
  return <div className="h-full w-full bg-white border-r border-border flex flex-col" data-id="element-373">
      <div className="h-16 border-b border-border flex items-center px-6" data-id="element-374">
        <Link to="/" className="flex items-center" data-id="element-375">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7xbpoURDQqszZgw3bqq8HE/Asika_New.svg" alt="Asika Logo" className="h-8" data-id="element-376" />
        </Link>
      </div>
      <div className="flex-1 overflow-y-auto py-4 px-3" data-id="element-377">
        <nav className="space-y-1" data-id="element-378">
          <Link to="/" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-379">
            <LayoutDashboard size={18} data-id="element-380" />
            <span data-id="element-381">Dashboard</span>
          </Link>
          <Link to="/appointments" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/appointments') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-382">
            <Calendar size={18} data-id="element-383" />
            <span data-id="element-384">Appointments</span>
          </Link>
          <Link to="/patients" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/patients') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-385">
            <UserCircle size={18} data-id="element-386" />
            <span data-id="element-387">Patients</span>
          </Link>
          <Link to="/messaging" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/messaging') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-388">
            <MessageSquare size={18} data-id="element-389" />
            <span data-id="element-390">Messaging</span>
          </Link>
          <Link to="/voice-agent" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/voice-agent') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-391">
            <Phone size={18} data-id="element-392" />
            <span data-id="element-393">Voice Agent</span>
          </Link>
          <Link to="/workflow" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/workflow') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-394">
            <GitBranch size={18} data-id="element-395" />
            <span data-id="element-396">Workflow</span>
          </Link>
          <Link to="/automation" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/automation') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-397">
            <Play size={18} data-id="element-398" />
            <span data-id="element-399">Automation</span>
          </Link>
          <Link to="/templates" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/templates') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-400">
            <FileText size={18} data-id="element-401" />
            <span data-id="element-402">Templates</span>
          </Link>
          <Link to="/analytics" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/analytics') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-403">
            <BarChart size={18} data-id="element-404" />
            <span data-id="element-405">Analytics</span>
          </Link>
          <Link to="/knowledge-base" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/knowledge-base') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-406">
            <Book size={18} data-id="element-407" />
            <span data-id="element-408">Knowledge Base</span>
          </Link>
          <div className="pt-4 pb-2" data-id="element-409">
            <div className="px-3 text-xs font-medium uppercase text-gray-500" data-id="element-410">
              Administration
            </div>
          </div>
          <div data-id="element-411">
            <button className={`w-full flex items-center justify-between px-3 py-2 rounded-md text-sm ${expandedSection === 'management' ? 'bg-gray-100 text-gray-900' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => toggleSection('management')} data-id="element-412">
              <div className="flex items-center gap-3" data-id="element-413">
                <Users size={18} data-id="element-414" />
                <span data-id="element-415">Management</span>
              </div>
              {expandedSection === 'management' ? <ChevronDown size={16} data-id="element-416" /> : <ChevronRight size={16} data-id="element-417" />}
            </button>
            {expandedSection === 'management' && <div className="pl-9 pr-3 py-1 space-y-1" data-id="element-418">
                <Link to="/user-management" className={`block px-3 py-1 rounded-md text-sm ${isActive('/user-management') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-419">
                  User Management
                </Link>
                <Link to="/roles" className={`block px-3 py-1 rounded-md text-sm ${isActive('/roles') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-420">
                  Roles & Permissions
                </Link>
                <Link to="/departments" className={`block px-3 py-1 rounded-md text-sm ${isActive('/departments') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-421">
                  Departments
                </Link>
              </div>}
          </div>
          <Link to="/settings" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${isActive('/settings') ? 'bg-black/10 text-black font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-422">
            <Settings size={18} data-id="element-423" />
            <span data-id="element-424">Settings</span>
          </Link>
        </nav>
      </div>
      <div className="p-4 border-t border-border" data-id="element-425">
        <div className="bg-black/5 rounded-md p-3" data-id="element-426">
          <div className="flex items-center gap-3 mb-2" data-id="element-427">
            <div className="h-8 w-8 rounded-full bg-black/20 flex items-center justify-center" data-id="element-428">
              <Phone size={16} className="text-black" data-id="element-429" />
            </div>
            <div data-id="element-430">
              <div className="text-sm font-medium" data-id="element-431">Voice Agent</div>
              <div className="text-xs text-muted-foreground" data-id="element-432">
                <span className="text-green-600" data-id="element-433">●</span> Active
              </div>
            </div>
          </div>
          <div className="text-xs text-gray-600" data-id="element-434">
            Maya AI has handled 28 calls today
          </div>
        </div>
      </div>
    </div>;
};
export default Sidebar;